// utils/authUtils.js

/**
 * Comprehensive password validation
 * @param {string} password - Password to validate
 * @returns {string|null} - Error message or null if valid
 */
export const validatePassword = (password) => {
  if (!password) return "Password is required";
  
  const minLength = 8;
  const hasUpper = /[A-Z]/.test(password);
  const hasLower = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  
  if (password.length < minLength) {
    return "Password must be at least 8 characters long";
  }
  if (!hasUpper) {
    return "Password must contain at least one uppercase letter";
  }
  if (!hasLower) {
    return "Password must contain at least one lowercase letter";
  }
  if (!hasNumber) {
    return "Password must contain at least one number";
  }
  if (!hasSpecial) {
    return "Password must contain at least one special character (!@#$%^&*)";
  }
  
  return null; // Valid password
};

/**
 * Normalize teacher ID (business logic extracted)
 * @param {string} username - Raw username
 * @returns {string} - Normalized teacher ID
 */
export const normalizeTeacherId = (username) => {
  if (!username) return '';
  
  // Remove trailing '01' if exists (your existing business rule)
  return username.replace(/01$/, '');
};